import { Teaser as t } from '@xprog/prensa/types'

export const TeaserCardBold: t.TeaserProps = {
  css: {
    mb: '$3',
    p: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      mb: '$0',
      width: 'auto'
    },
    '.TeaserSubject': {
      mb: '$0',
      color: '#4D4D4D'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      fontSize: '20px',
      letterSpacing: '0.2px',
      lineHeight: '24px',
      fontWeight: 500
    },
    '.TeaserWrap': {
      minHeight: '132px',
      pt: '$3'
    },
    '@lg': {
      mb: '$0'
    }
  },
  className: 'TeaserCardBold',
  imageDerivative: '3x2',
  imageVariant: 'top',
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-lg'
}
